import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_MEDIUM_SCREEN_850,
} from 'client/constants/mediaQueries';

import { HOUSEHOLD_LISTING_ARCHIVED_REASON_DENIED } from 'common/householdConstants';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import SrButton, {
  SR_BUTTON_THEME_BLUR,
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

const ARCHIVED_DENIED_NOT_CREDIT_REPORT =
  'This application has moved to the “Archived” tab on your listing page.' +
  ' Sunroom sent the renter a denial notice.';
const ARCHIVED_DENIED_CREDIT_REPORT =
  'This application has moved to the “Archived” tab on your listing page.' +
  ' Sunroom sent the renter both a denial and adverse action notice.';
const ARCHIVED_NOT_DENIED =
  'This application has moved to the “Archived” tab on your listing page.' +
  ' Please know that you are responsible for communicating with the renter.' +
  ' Sunroom will not notify the renter that the application is archived';

const SrArchiveSuccessModalSunScreen = ({ onClose, archiveFormValues }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });
  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_850,
  });

  const reasonText =
    archiveFormValues.cancelReason === HOUSEHOLD_LISTING_ARCHIVED_REASON_DENIED
      ? archiveFormValues.rejectedForCreditReport
        ? ARCHIVED_DENIED_CREDIT_REPORT
        : ARCHIVED_DENIED_NOT_CREDIT_REPORT
      : ARCHIVED_NOT_DENIED;

  return (
    <SrModalV2
      centerContent
      closeOnBackgroundClick
      showCloseButton={false}
      contentMaxWidth={!isSmallScreen ? '375px' : null}
      padding={isSmallScreen ? 'calc(100vh - 660px) 0 0 0' : '0 0 120px 0'}
      contentPadding="0"
      onClose={onClose}
      theme={isSmallScreen ? MODAL_THEME_FIXED_FOOTER_BUTTON : null}
      buttonTheme={isSmallScreen ? SR_BUTTON_THEME_ADOBE_GREY : SR_BUTTON_THEME_BLUR}
    >
      <SrBox
        borderRadius={isMediumScreen ? '14px' : '24px'}
        backgroundColor="white"
        boxShadow="0px 15px 26px rgba(212, 212, 212, 0.17)"
        boxSizing="border-box"
        maxWidth="375px"
        width={isSmallScreen ? 'calc(100vw - 20px)' : '375px'}
        padding="48px 40px 40px"
        margin={isMediumScreen ? '0 auto' : null}
      >
        <SrBox
          margin="0 auto"
          backgroundSize="cover"
          backgroundRepeat="no-repeat"
          backgroundPosition="center"
          backgroundImage="url(/images/checkmarkSuccessGreen.svg)"
          width="109px"
          height="109px"
          position="relative"
          zIndex="5"
          marginBottom="18px"
        />
        <SrFlex justify="center" direction="col">
          <SrFlex marginBottom="16px" justify="center">
            <SrText
              color="blueGreycliff"
              font="greycliff"
              weight="800"
              fontSize="26px"
              lineHeight="33px"
              align="center"
            >
              Archived Application
            </SrText>
          </SrFlex>
          <SrFlex marginBottom="18px" justify="center" direction="col">
            <SrText
              color="blueGreycliff"
              font="greycliff"
              weight="600"
              fontSize="16px"
              lineHeight="24px"
              align="center"
            >
              {reasonText}
            </SrText>
          </SrFlex>
          <SrButton theme={SR_BUTTON_THEME_ADOBE_GREEN} onClick={onClose}>
            Ok, thanks
          </SrButton>
        </SrFlex>
      </SrBox>
    </SrModalV2>
  );
};

SrArchiveSuccessModalSunScreen.propTypes = {
  onClose: PropTypes.func.isRequired,
  archiveFormValues: PropTypes.object.isRequired,
};

SrArchiveSuccessModalSunScreen.displayName = 'SrArchiveSuccessModalSunScreen';

export default SrArchiveSuccessModalSunScreen;
